import { put, call, all, takeLatest } from 'redux-saga/effects'
import services from '../../services'

import {
  GetOneResponsible,
  GET_ONE_RESPONSIBLE,
  GET_ONE_RESPONSIBLE_ERROR,
  GET_ONE_RESPONSIBLE_SUCCESS,
} from '../types/responsible/get-one'

import {
  GetAllResponsibles,
  GET_ALL_RESPONSIBLES,
  GET_ALL_RESPONSIBLES_ERROR,
  GET_ALL_RESPONSIBLES_SUCCESS,
} from '../types/responsible/get-all'

import {
  NewResponsible,
  NEW_RESPONSIBLE,
  NEW_RESPONSIBLE_ERROR,
  NEW_RESPONSIBLE_SUCCESS,
} from '../types/responsible/new'

import {
  EditResponsible,
  EDIT_RESPONSIBLE,
  EDIT_RESPONSIBLE_ERROR,
  EDIT_RESPONSIBLE_SUCCESS,
} from '../types/responsible/edit'

import {
  EDIT_RESPONSIBLE_TYPES,
  EDIT_RESPONSIBLE_TYPES_ERROR,
  EDIT_RESPONSIBLE_TYPES_SUCCESS,
} from '../types/responsible/edit-responsible-types'

import {
  DeleteResponsible,
  DELETE_RESPONSIBLE,
  DELETE_RESPONSIBLE_ERROR,
  DELETE_RESPONSIBLE_SUCCESS,
} from '../types/responsible/delete'

import {
  GetResponsibleCustomers,
  GET_RESPONSIBLE_CUSTOMERS,
  GET_RESPONSIBLE_CUSTOMERS_ERROR,
  GET_RESPONSIBLE_CUSTOMERS_SUCCESS,
} from '../types/responsible/get-customers'

function* getOneResponsible({ payload }) {
  try {
    const { response, error } = yield call(services.responsible.getOne, payload)
    if (error) {
      yield put({
        type: GET_ONE_RESPONSIBLE_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield put({
        type: GET_ONE_RESPONSIBLE_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ONE_RESPONSIBLE_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

function* getResponsibleCustomers({ payload }) {
  try {
    const { response, error } = yield call(services.customer.getAll, payload)
    if (error) {
      yield put({
        type: GET_RESPONSIBLE_CUSTOMERS_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield put({
        type: GET_RESPONSIBLE_CUSTOMERS_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_RESPONSIBLE_CUSTOMERS_ERROR,
      payload: 'Error al obtener clientes de un responsable',
    })
  }
}

function* getAllResponsibles({ payload }) {
  try {
    const { response, error } = yield call(services.responsible.getAll, payload)
    if (error) {
      yield put({
        type: GET_ALL_RESPONSIBLES_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield put({
        type: GET_ALL_RESPONSIBLES_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ALL_RESPONSIBLES_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

function* newResponsible({ payload }) {
  try {
    const { response, error } = yield call(services.responsible.new, payload)
    if (error) {
      yield put({
        type: NEW_RESPONSIBLE_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield put({
        type: NEW_RESPONSIBLE_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: NEW_RESPONSIBLE_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

function* editResponsible({ payload }) {
  try {
    const { response, error } = yield call(services.responsible.edit, payload)
    if (error) {
      yield put({
        type: EDIT_RESPONSIBLE_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield all([
        put({
          type: EDIT_RESPONSIBLE_SUCCESS,
          payload: response,
        }),
        yield put({
          type: GET_ONE_RESPONSIBLE_SUCCESS,
          payload: response,
        }),
      ])
    }
  } catch {
    yield put({
      type: EDIT_RESPONSIBLE_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

function* editResponsibleTypes({ payload }) {
  try {
    const { response, error } = yield call(services.responsible.edit, payload)
    if (error) {
      yield put({
        type: EDIT_RESPONSIBLE_TYPES_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield all([
        put({
          type: EDIT_RESPONSIBLE_TYPES_SUCCESS,
          payload: response,
        }),
        yield put({
          type: GET_ONE_RESPONSIBLE_SUCCESS,
          payload: response,
        }),
      ])
    }
  } catch {
    yield put({
      type: EDIT_RESPONSIBLE_TYPES_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

function* deleteResponsible({ payload }) {
  try {
    const { response, error } = yield call(services.responsible.deleteOne, payload)
    if (error) {
      yield put({
        type: DELETE_RESPONSIBLE_ERROR,
        payload: error?.response?.status,
      })
    } else {
      yield put({
        type: DELETE_RESPONSIBLE_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: DELETE_RESPONSIBLE_ERROR,
      payload: 'Error al obtener información de usuario',
    })
  }
}

/**
 * Watchers
 */
export default function* applicant() {
  yield takeLatest<GetOneResponsible>(GET_ONE_RESPONSIBLE, getOneResponsible)
  yield takeLatest<GetAllResponsibles>(GET_ALL_RESPONSIBLES, getAllResponsibles)
  yield takeLatest<NewResponsible>(NEW_RESPONSIBLE, newResponsible)
  yield takeLatest<EditResponsible>(EDIT_RESPONSIBLE, editResponsible)
  yield takeLatest<DeleteResponsible>(DELETE_RESPONSIBLE, deleteResponsible)
  yield takeLatest<DeleteResponsible>(EDIT_RESPONSIBLE_TYPES, editResponsibleTypes)
  yield takeLatest<GetResponsibleCustomers>(GET_RESPONSIBLE_CUSTOMERS, getResponsibleCustomers)
}
